module.exports = __webpack_public_path__ + "static/img/kid-vaccine.9529195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Uphc/Uphc-pics/kid-vaccine.jpg
// module id = IIjP
// module chunks = 0